// src/components/pages/TermsAndConditions.js
import React, { useEffect } from 'react';
import SeoHead from '../seo/SeoHead';
import { Box, Container, Typography, useTheme } from '@mui/material';

export default function TermsAndConditions() {
  const theme = useTheme();

  // scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SeoHead
        title="Terms & Conditions – Marrakech Reserve"
        description="Review the Terms & Conditions governing your use of Marrakech Reserve’s website and purchase of our premium olive oils."
        url="https://marrakech-reserve.com/terms-conditions"
        keywords="terms and conditions, Marrakech Reserve, olive oil sales, website terms, user agreement, purchase policy, shipping policy, return policy"
      />

      <Box sx={{ bgcolor: theme.palette.background.default, py: { xs: 6, md: 10 } }}>
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
            Terms & Conditions
          </Typography>

          <Typography variant="body1" paragraph>
            These Terms & Conditions (“Terms”) govern your access to and use of the Marrakech Reserve website (the “Site”) and any purchases you make of our extra‑virgin olive oils and related products (“Products”). By using the Site or placing an order, you agree to these Terms.
          </Typography>

          <Typography variant="h6" gutterBottom>
            1. Orders & Acceptance
          </Typography>
          <Typography variant="body1" paragraph>
            All orders are subject to availability and acceptance by Marrakech Reserve. We reserve the right to refuse or cancel any order for any reason, including errors in pricing or product information.
          </Typography>

          <Typography variant="h6" gutterBottom>
            2. Pricing & Payment
          </Typography>
          <Typography variant="body1" paragraph>
            Prices are shown in EUR and include applicable taxes unless stated otherwise. Payment is processed securely via Stripe. You agree to pay all charges incurred by your use of the Site at the prices then in effect.
          </Typography>

          <Typography variant="h6" gutterBottom>
            3. Shipping & Delivery
          </Typography>
          <Typography variant="body1" paragraph>
            We ship worldwide. Delivery estimates are provided at checkout but are not guaranteed. Risk of loss passes to you upon our delivery to the carrier.
          </Typography>

          <Typography variant="h6" gutterBottom>
            4. Returns & Cancellations
          </Typography>
          <Typography variant="body1" paragraph>
            We stand behind our Products. If you receive damaged or incorrect items, please contact us within 7 days of delivery at <a href="mailto:support@marrakech-reserve.com">support@marrakech-reserve.com</a>. Cancellations may be accepted up to 24 hours after order placement.
          </Typography>

          <Typography variant="h6" gutterBottom>
            5. Intellectual Property
          </Typography>
          <Typography variant="body1" paragraph>
            All content on the Site, including text, graphics, logos, and images, is the property of Marrakech Reserve or its licensors and is protected by copyright and other intellectual property laws.
          </Typography>

          <Typography variant="h6" gutterBottom>
            6. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            To the fullest extent permitted by law, Marrakech Reserve and its affiliates will not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Site or purchase of Products.
          </Typography>

          <Typography variant="h6" gutterBottom>
            7. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These Terms are governed by and construed in accordance with the laws of Morocco, and you submit to the exclusive jurisdiction of the courts in Marrakech for any disputes.
          </Typography>

          <Typography variant="h6" gutterBottom>
            8. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We may update these Terms at any time. The revised date will be posted at the top of this page. Your continued use of the Site constitutes acceptance of the updated Terms.
          </Typography>

          <Typography variant="h6" gutterBottom>
            9. Contact Us
          </Typography>
          <Typography variant="body1">
            If you have questions about these Terms, please contact us at<br/>
            <a href="mailto:support@marrakech-reserve.com">support@marrakech-reserve.com</a><br/>
            or write to:<br/>
            Marrakech Reserve<br/>
            17 Rue Yougouslavia<br/>
            Marrakech, Morocco
          </Typography>
        </Container>
      </Box>
    </>
  );
}
